/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_TabInputs */

const en_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription`)
};

const fr_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const de_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement`)
};

const it_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottoscrizione`)
};

const ru_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка`)
};

const es_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscripción`)
};

const zh_cn2_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

const ja_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプション`)
};

const hi_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता`)
};

const pt_pt2_subscription_tab = /** @type {(inputs: Subscription_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscrição`)
};

/**
* | output |
* | --- |
* | "Subscription" |
*
* @param {Subscription_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subscription_tab = /** @type {((inputs?: Subscription_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subscription_tab(inputs)
	if (locale === "de") return de_subscription_tab(inputs)
	if (locale === "it") return it_subscription_tab(inputs)
	if (locale === "ru") return ru_subscription_tab(inputs)
	if (locale === "es") return es_subscription_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_subscription_tab(inputs)
	if (locale === "ja") return ja_subscription_tab(inputs)
	if (locale === "hi") return hi_subscription_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_subscription_tab(inputs)
	return en_subscription_tab(inputs)
});